import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Users, Building2 } from 'lucide-react';

/**
 * Switcher entre Landing de Compradores y Landing de Negocios
 * Se muestra en ambas landings para facilitar navegación
 * En móvil se oculta del header para mantener diseño limpio Apple-style
 */
export const LandingSwitcher = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const lang = i18n.language?.substring(0, 2) || 'es';
  
  const isBusinessPage = location.pathname === '/para-negocios';
  
  const labels = {
    es: { shopper: 'Soy Comprador', business: 'Tengo un Negocio' },
    en: { shopper: 'I\'m a Shopper', business: 'I have a Business' },
    fr: { shopper: 'Je suis Acheteur', business: 'J\'ai un Commerce' }
  };
  
  const l = labels[lang] || labels.es;

  return (
    <div className="hidden md:block fixed top-20 left-1/2 -translate-x-1/2 z-40" data-testid="landing-switcher">
      <div className="flex items-center bg-gray-900/90 backdrop-blur-md rounded-full p-1 border border-gray-700 shadow-lg">
        <Link
          to="/"
          className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
            !isBusinessPage 
              ? 'bg-emerald-600 text-white shadow-md' 
              : 'text-gray-400 hover:text-white'
          }`}
          data-testid="switch-to-shopper"
        >
          <Users className="w-4 h-4" />
          <span>{l.shopper}</span>
        </Link>
        
        <Link
          to="/para-negocios"
          className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
            isBusinessPage 
              ? 'bg-amber-600 text-white shadow-md' 
              : 'text-gray-400 hover:text-white'
          }`}
          data-testid="switch-to-business"
        >
          <Building2 className="w-4 h-4" />
          <span>{l.business}</span>
        </Link>
      </div>
    </div>
  );
};

export default LandingSwitcher;
